module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.user && this.$store.state.user.is_admin) ? _c('div', [(_vm.message) ? _c('p', [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "user"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "one column"
    }, [_vm._v(_vm._s(user.pk_user_id))]), _vm._v(" "), _c('div', {
      staticClass: "three columns"
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('div', {
      staticClass: "eight columns"
    }, [_vm._v(_vm._s(user.email))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "four columns"
    }, [_vm._v(_vm._s(user.posts_made) + " Posts")]), _vm._v(" "), _c('div', {
      staticClass: "four columns"
    }, [_vm._v(_vm._s(user.votes_cast) + " Votes")]), _vm._v(" "), _c('div', {
      staticClass: "four columns"
    }, [_vm._v(_vm._s(user.times_won) + " Wins")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "four columns"
    }, [_c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.resetPassword(user.email)
        }
      }
    }, [_vm._v("Reset PW")])]), _vm._v(" "), _c('div', {
      staticClass: "four columns"
    }, [_c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.deleteUser(user.pk_user_id)
        }
      }
    }, [_vm._v("Delete")])]), _vm._v(" "), _c('div', {
      staticClass: "four columns"
    }, [_c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.nukeUser(user.pk_user_id)
        }
      }
    }, [_vm._v("Nuke")])])])])
  })], 2) : _c('div', [_vm._v("\n  Nope\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ea53b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Reset.vue
// module id = 269
// module chunks = 1